import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { MaskLines, Reveal } from "./Reveal";
import { STATS } from "../data/content";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2.4,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <span ref={ref} data-testid={`stat-number-${value}`}>
      {display.toLocaleString("en-US")}{suffix}
    </span>
  );
};

export const Numbers = () => {
  return (
    <section data-testid="numbers-section" className="px-3 sm:px-5 lg:px-8 py-6">
      <div className="bg-charcoal text-cream rounded-[2rem] sm:rounded-[3rem] px-6 sm:px-12 lg:px-20 py-20 sm:py-28 relative overflow-hidden noise-overlay">
      <MaskLines
        as="h2"
        lines={[<>Experience has a way <span className="font-serif italic font-normal">of adding up.</span></>]}
        className="font-display font-medium tracking-[-0.03em] leading-[1.05] text-3xl sm:text-5xl lg:text-6xl max-w-3xl"
      />
        <div className="mt-16 sm:mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.1}>
              <div className="group" data-testid={`stat-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <div className="font-mono font-bold tracking-tighter text-5xl sm:text-6xl lg:text-7xl text-cream transition-transform duration-500 origin-left group-hover:scale-[1.04]">
                  <Counter value={s.value} suffix={s.suffix} />
                </div>
                <p className="mt-3 font-mono text-[10px] sm:text-xs tracking-[0.24em] text-flame">{s.label}</p>
                <p className="mt-3 text-sm text-cream/55 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
